export const EN_LANGUAGE = "en";
